// extracted by mini-css-extract-plugin
export default {"helpContent":"helpContent__rPJdth","shortcut":"shortcut__Bt09up"};